import React, { useState, useEffect } from 'react';
import ReturnOptionTypeMethod from './ReturnOptionTypeMethod';
import {
  getReturnActions,
  setIsExchange,
  getOrderItemsReturnElgibilty,
  setCurrentReturnItem,
} from '../../../../actionCreators/returnExchange';
import { connect } from 'react-redux';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import { getProductReturnStatus } from '../../../../utils/helper';

const ReturnTypeMethod = props => {
  const {
    isExpandable,
    setIsExpandable,
    returnConfig,
    returnEligibiliyDetails,
    setFourthStep,
    setFinalStep,
    setCurrentReturnItem,
    setIsExchange,
    currentReturnItem,
    location,
    match,
    isExchange,
    orderDetails,
    setFifthStep,
    item,
    redisCommonData,
    dataLocale,
    returnIdItem,
    isExchangeOnlyCase,
  } = props;
  const {
    EXCHANGE_OR_REFUND,
    EXCHANGE,
    REFUND,
    WHAT_WOULD_YOU_LIKE_TO_DO_EXCHANGE_REFUND,
    CHANGE,
  } = dataLocale;
  const data = sessionStorageHelper.getItem('returnStep') || {};
  const [selectedType, setSelectedType] = useState(data?.returnType || '');
  const [returnMethodsUpdated, setReturnMethodsUpdated] = useState(null);
  const [allModesDisabled, setAllModesDisabled] = useState(null);
  const [customerWallet, setCustomerWallet] = useState(null);
  const [exchangeMethod, setExchangeMethod] = useState(data?.exchangeMethodText || null);
  const [selectedSecondaryType, setSelectedSecondaryType] = useState(data?.refundType || null);
  const items =
    orderDetails && orderDetails?.result?.orders && orderDetails?.result?.orders[0]?.items;
  const [exchangeMethods, setexchangeMethods] = useState('');
  const [refundMethods, setrefundMethods] = useState('');
  const packageTypes = [
    'zero_power',
    'single_vision',
    'bifocal',
    'tinted_sv',
    'contact_lens',
    'sunglasses',
  ];

  useEffect(() => {
    const returnItemId = match?.params?.itemId;
    if (returnItemId && items && items.length && returnEligibiliyDetails) {
      const returnProductItems = items.filter(
        item => parseInt(returnItemId, 10) === parseInt(item.id, 10)
      ); // eslint-disable-line
      const currentItemReturnEligibiliyDetails =
        returnEligibiliyDetails.items?.find(
          item => parseInt(item.id, 10) === parseInt(returnItemId, 10)
        ) || {}; // eslint-disable-line
      setCurrentReturnItem({
        item: { ...returnProductItems[0], ...currentItemReturnEligibiliyDetails },
      });
    }
  }, [returnEligibiliyDetails, orderDetails]);
  const getExchangeMethods = () => {
    const { powerRequired, thumbnail } = currentReturnItem?.item || {};
    let isPowerItem;
    if (powerRequired && powerRequired === 'POWER_SUBMITTED') {
      isPowerItem = true;
    }
    const returnItemId = match?.params?.itemId;
    const returnActionsDetail = returnEligibiliyDetails?.items.find(
      item => parseInt(item.id, 10) === parseInt(returnItemId, 10)
    );
    const { exchangeMethods = [] } =
      returnActionsDetail?.exchangeMethods?.length > 0
        ? returnActionsDetail
        : currentReturnItem?.item;
    let { chooseExchangeMode: modeOfExchange } = returnConfig;
    modeOfExchange = (modeOfExchange && modeOfExchange[isPowerItem ? 'power' : 'nonpower']) || {};
    const configExchangeMethods = exchangeMethods.reduce((memo, method) => {
      const { name, enabled } = method;
      const exchangeMethod = modeOfExchange[name] ? { ...modeOfExchange[name] } : null;
      if (exchangeMethod) {
        exchangeMethod.id = name;
        if (name === 'SAMEPRODUCT') {
          exchangeMethod.image = thumbnail;
        }
        exchangeMethod.subText = { ...exchangeMethod.subText };
        if (!exchangeMethod.error) exchangeMethod.error = {};
        if ((exchangeMethod.subText && exchangeMethod.subText.contents) || exchangeMethod.title) {
          const { options, brandName, lensCategory } = item;
          let { lensType } = item;
          lensType = lensType.toLowerCase();
          let lensPackage;
          let coating;
          let type;
          for (let i = 0, len = options.length; i < len; i++) {
            type = options[i].type && options[i].type.toLowerCase();
            if (packageTypes.includes(type)) {
              lensPackage = options[i].name;
            } else if (type === 'coating') {
              coating = options[i].name;
            }
          }
          const vision = lensType !== 'NORMAL' ? lensType.replace('_', ' ') : '';
          if (exchangeMethod.title) {
            exchangeMethod.title = exchangeMethod.title.replace(
              '<type>',
              lensCategory.toLowerCase() || ''
            );
          }
          if (exchangeMethod.subText && exchangeMethod.subText.contents) {
            exchangeMethod.subText.contents = exchangeMethod.subText.contents.map(content => {
              return content
                .replace('<brand>', brandName || '')
                .replace('<coating>', (coating && ` + ${coating}`) || '')
                .replace('<lensPackage>', (lensPackage && ` + ${lensPackage}`) || '')
                .replace('<vision>', vision || '')
                .replace('<type>', lensCategory.toLowerCase() || '');
            });
          }
        }
        exchangeMethod.error.status = !enabled;
        memo.push(exchangeMethod);
      }
      return memo;
    }, []);
    setexchangeMethods(configExchangeMethods);
  };

  const getRefundMethods = () => {
    const returnItemId = match?.params?.itemId;
    const { chooseRefundMode: modeOfRefund } = returnConfig;
    let customerWallet = true;
    let renderRefundMethods;
    returnEligibiliyDetails?.items?.forEach(item => {
      if (parseInt(item.id, 10) === parseInt(returnItemId, 10)) {
        renderRefundMethods = item?.refundMethods.reduce((memo, method) => {
          const { name, enabled } = method;
          const refundMethod = modeOfRefund[name] ? { ...modeOfRefund[name] } : null;
          if (refundMethod) {
            refundMethod.id = name;
            if (!refundMethod.error) refundMethod.error = {};
            refundMethod.error.status = !enabled;
            memo.push(refundMethod);
            if (refundMethod.error.status === false) customerWallet = false;
          }
          return memo;
        }, []);
      }
    });
    setCustomerWallet(customerWallet);
    setrefundMethods(renderRefundMethods);
  };

  const updateRenderModes = () => {
    const { choosePostReturnMode } = returnConfig;
    const {
      item: { isRefundable, isExchangeable },
    } = currentReturnItem;
    const configPostReturnMethods = { ...choosePostReturnMode };
    const { RECEIVED_BY_LENSKART } = dataLocale;
    const renderMethods = [];
    const allModesDisabled = !isExchangeable && !isRefundable;
    configPostReturnMethods.exchange.id = 'exchange';
    configPostReturnMethods.refund.id = 'refund';
    const returnStatus = getProductReturnStatus();
    if (isExchangeable && isRefundable) {
      renderMethods.push(configPostReturnMethods.exchange);
      renderMethods.push(configPostReturnMethods.refund);
    } else if (isExchangeable || isRefundable) {
      renderMethods.push(
        (isExchangeable && configPostReturnMethods.exchange) ||
          (isRefundable && configPostReturnMethods.refund)
      );
    }
    const returnMethodsUpdated = JSON.parse(JSON.stringify(renderMethods));
    returnMethodsUpdated.forEach(method => {
      if (method?.subText?.contents) {
        method.subText.contents = method.subText.contents.map(content => {
          return content.replace(
            '(pickedupStatus)',
            `<span>${returnStatus || RECEIVED_BY_LENSKART}</span>`
          );
        });
      }
    });
    setReturnMethodsUpdated(returnMethodsUpdated);
    setAllModesDisabled(allModesDisabled);
  };

  useEffect(() => {
    if (isExchange) setIsExchange(false);
    if (
      ((returnEligibiliyDetails && returnEligibiliyDetails.items) ||
        currentReturnItem?.item.exchangeMethods) &&
      returnConfig &&
      currentReturnItem
    ) {
      getExchangeMethods();
    }
    if (returnEligibiliyDetails && returnEligibiliyDetails.items) {
      getRefundMethods();
    }
    if (currentReturnItem) updateRenderModes();
  }, [currentReturnItem, returnEligibiliyDetails]);

  const handleChange = () => {
    setExchangeMethod(null);
    setIsExpandable(EXCHANGE_OR_REFUND);
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    returnStep = {
      ...returnStep,
      fourthStep: false,
      fifthStep: false,
      finalStep: '',
      isExpandable: EXCHANGE_OR_REFUND,
    };
    sessionStorageHelper.setItem('returnStep', returnStep);
    setSelectedSecondaryType(null);
    if (
      (returnEligibiliyDetails?.items || currentReturnItem?.item.exchangeMethods) &&
      returnConfig
    ) {
      getExchangeMethods();
    }
    if (returnEligibiliyDetails) {
      getRefundMethods();
    }
    setFourthStep(false);
    setFifthStep(false);
    setFinalStep('');
  };

  const addType = value => {
    setSelectedType(value === 'refund' ? REFUND : EXCHANGE);
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    returnStep = {
      ...returnStep,
      returnType: value === 'refund' ? REFUND : EXCHANGE,
    };
    sessionStorageHelper.setItem('returnStep', returnStep);
  };

  return (
    <>
      <div className="bora-8 margin-10 order-box">
        <div
          className={`padding-15 ${isExpandable !== EXCHANGE_OR_REFUND ? 'bg-white' : 'bg-cyan'}`}
        >
          <span
            className={`fs15 futur-std  ${
              isExpandable !== EXCHANGE_OR_REFUND ? 'text-color-grey fw500' : 'fw600'
            }`}
          >{`${
            isExchangeOnlyCase || returnIdItem ? 1 : 3
          }. ${WHAT_WOULD_YOU_LIKE_TO_DO_EXCHANGE_REFUND}`}</span>
          {isExpandable !== EXCHANGE_OR_REFUND && (
            <span
              className="float-right margin-r10 text-uppercase text-link"
              onClick={handleChange}
            >
              {CHANGE}
            </span>
          )}
          {isExpandable !== EXCHANGE_OR_REFUND && (
            <div className="margin-t5">
              <span className="margin-l20">{selectedType}</span>
              <span className="margin-l8 text-color-grey">
                {exchangeMethod || selectedSecondaryType}
              </span>
            </div>
          )}
        </div>
        {isExpandable === EXCHANGE_OR_REFUND && (
          <ReturnOptionTypeMethod
            addType={addType}
            allModesDisabled={allModesDisabled}
            customerWallet={customerWallet}
            dataLocale={dataLocale}
            location={location}
            match={match}
            modeOfRefund={refundMethods}
            modes={exchangeMethods}
            redisCommonData={redisCommonData}
            returnMethodsUpdated={returnMethodsUpdated}
            setExchangeMethod={setExchangeMethod}
            setFinalStep={setFinalStep}
            setFourthStep={setFourthStep}
            setIsExpandable={setIsExpandable}
            setSelectedSecondaryType={setSelectedSecondaryType}
            singleItemDetail={
              returnEligibiliyDetails &&
              returnEligibiliyDetails.items &&
              returnEligibiliyDetails.items[0]
            }
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
    returnEligibiliyDetails: state.returnExchange.returnEligibiliyDetails,
    returnEligibiliyDetailsLoading: state.returnExchange.returnEligibiliyDetailsLoading,
    itemReturnDetails: state.returnExchange.itemReturnDetails,
    isExchange: state.returnExchange.isExchange,
    orderDetails: state.order.orderDetails,
    currentReturnItem: state.returnExchange.currentReturnItem,
    redisCommonData: state.common.redisCommonData,
    returnConfig: state.myAccount.returnConfig,
  };
};
function mapDispatchToProps(dispatch) {
  return {
    getReturnActions: (orderId, itemId) => dispatch(getReturnActions(orderId, itemId)),
    setIsExchange: flag => dispatch(setIsExchange(flag)),
    setCurrentReturnItem: data => dispatch(setCurrentReturnItem(data)),
    getOrderItemsReturnElgibilty: data => dispatch(getOrderItemsReturnElgibilty(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnTypeMethod);
